import * as React from "react";
import ActiveButton from "./ActiveButton";
import PageButtonLink from "./PageButtonLink";
const Pages = ({
  pageCount,
  selectedPage,
  onPageChange,
  enlargement = 1,
  size
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array(...Array(pageCount)).map((_, index) => {
    const key = index + enlargement;
    return selectedPage === key ? /*#__PURE__*/React.createElement(ActiveButton, {
      key: key,
      size: size
    }, key) : /*#__PURE__*/React.createElement(PageButtonLink, {
      key: key,
      onPageChange: onPageChange,
      size: size
    }, key);
  }));
};
export default Pages;